<template>
  <div class="dashboard">
    <b-container v-if="!isLoading">
      <b-row class="summary">
        <b-col md="8" class="left-summ">
          <h5>{{labels.summary}}</h5>
          <h2>{{ invoicesChartTotal + " " + labels.invoices}} </h2>
          <div class="chart" v-if="invoicesChartDays.length != 0">
            <div
              :class="[
                maxValuePosition == 4 ? 'active-bar' : '',
                'bar-' + invoicesChartNumbers[4],
              ]"
              v-if="invoicesChartDays.length > 4"
            >
              <span class="day-4">{{ invoicesChartDays[4] }}</span>
            </div>
            <div
              :class="[
                maxValuePosition == 3 ? 'active-bar' : '',
                'bar-' + invoicesChartNumbers[3],
              ]"
              v-if="invoicesChartDays.length > 3"
            >
              <span class="day-3">{{ invoicesChartDays[3] }}</span>
            </div>
            <div
              :class="[
                maxValuePosition == 2 ? 'active-bar' : '',
                'bar-' + invoicesChartNumbers[2],
              ]"
              v-if="invoicesChartDays.length > 2"
            >
              <span class="day-2">{{ invoicesChartDays[2] }}</span>
            </div>
            <div
              :class="[
                maxValuePosition == 1 ? 'active-bar' : '',
                'bar-' + invoicesChartNumbers[1],
              ]"
              v-if="invoicesChartDays.length > 1"
            >
              <span class="day-1">{{ invoicesChartDays[1] }}</span>
            </div>
            <div
              :class="[
                maxValuePosition == 0 ? 'active-bar' : '',
                'bar-' + invoicesChartNumbers[0],
              ]"
              v-if="invoicesChartDays.length > 0"
            >
              <span class="day-0">{{ invoicesChartDays[0] }}</span>
            </div>
          </div>
          <div v-else>
            <h3>{{labels.noInvoices}}</h3>
          </div>
        </b-col>
        <b-col md="4" class="right-summ">
          <div class="big-number">
            <h5>{{labels.total}}</h5>
            <h1>{{ invoicesTotal }}</h1>
            <span class="circle-1"></span>
            <span class="circle-2"></span>
          </div>
        </b-col>
      </b-row>
      <b-row class="summaryNew">
        <b-col md="10" class="left-summ">
          <h5>{{labels.monthlySummary}}</h5>
          <div class="chart table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">{{labels.monthJanua}}</th>
                  <th scope="col">{{labels.monthFebrua}}</th>
                  <th scope="col">{{labels.monthMarch}}</th>
                  <th scope="col">{{labels.monthApril}}</th>
                  <th scope="col">{{labels.monthMay}}</th>
                  <th scope="col">{{labels.monthJune}}</th>
                  <th scope="col">{{labels.monthJuly}}</th>
                  <th scope="col">{{labels.monthAugust}}</th>
                  <th scope="col">{{labels.monthSeptember}}</th>
                  <th scope="col">{{labels.monthOctober}}</th>
                  <th scope="col">{{labels.monthNovember}}</th>
                  <th scope="col">{{labels.monthDecember}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td scope="col">{{januaMont.length}}</td>
                  <td scope="col">{{februMont.length}}</td>
                  <td scope="col">{{marchMont.length}}</td>
                  <td scope="col">{{aprilMont.length}}</td>
                  <td scope="col">{{mayMont.length}}</td>
                  <td scope="col">{{juneMont.length}}</td>
                  <td scope="col">{{julyMont.length}}</td>
                  <td scope="col">{{augustMont.length}}</td>
                  <td scope="col">{{septeMont.length}}</td>
                  <td scope="col">{{octobMont.length}}</td>
                  <td scope="col">{{novembMont.length}}</td>
                  <td scope="col">{{decembMont.length}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
        <b-col md="2" class="right-summ">
          <h6>{{labels.selectState}}</h6>
          <div class="invoiceSelect">
            <!-- <md-field>
              <label for="invStatus">{{labels.statusInv}} </label>
              <md-select id="invStatus" v-model="statusInvoice" @change="prueba($event)">
                <md-option value="APP">{{labels.approved}}</md-option>
                <md-option value="CHK">{{labels.checked}}</md-option>
                <md-option value="DEC">{{labels.declined}}</md-option>
                <md-option value="PND">{{labels.pending}}</md-option>
              </md-select>
            </md-field> -->
            <select id="invStatus" class="form-control-sm" v-model="statusInvoice" @change="statusMonthly()">
              <option value="APP">{{labels.approved}}</option>
              <option value="CHK">{{labels.checked}}</option>
              <option value="DEC">{{labels.declined}}</option>
              <option value="PND">{{labels.pending}}</option>
            </select>
          </div>
          <div class="text-center ">
            <b-spinner v-if="spinn == true"></b-spinner>
          </div>
          <div class="text-center invoiceTotal">
            <h3 v-if="spinn == false">{{listStatusInv.length}}</h3>
          </div>
        </b-col>
      </b-row>
      <b-row class="others">
        <b-col lg="6" class="pr-lg-3">
          <div class="users">
            <h5>{{labels.users}}</h5>
            <table>
              <tbody>
                <tr v-for="item in users" :key="item.id">
                  <td>{{ item.username }}</td>
                  <td v-if="item.enabled" class="user-active">{{labels.active}}</td>
                  <td v-else class="user-inactive">{{labels.inactive}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="providers">
            <div class="total-profivers">
              <h6>{{labels.providers}}</h6>
              <h2>{{ providersTotal }}</h2>
            </div>
            <div class="icon">
              <font-awesome-icon :icon="['fas', 'globe']" />
            </div>
          </div>
        </b-col>
        <b-col lg="6" class="pl-lg-3">
          <div class="last-invoices">
            <h5>{{labels.lastInvoices}}</h5>
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{labels.provider}}</th>
                  <th>{{labels.date}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in lastInvoices" :key="item.id">
                  <td>{{ item.number }}</td>
                  <td>{{ item.provider }}</td>
                  <td>{{ item.createdAt }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-row v-else>
      <b-col md="12" lg="12" class="p-4 mx-audo">
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Invoice from "@/services/Invoice";
import Provider from "@/services/Provider";

import User from "@/services/User";

export default {
  name: "List",

  data: () => ({
    currentSort: "createdAt",
    currentSortOrder: "asc",
    showDialog: false,
    dialogItem: {},
    inscriptions: [],
    searched: [],
    search: null,
    isEmpty: false,
    isUpdating: false,
    isLoading: false,
    success: false,
    error: false,
    spinn: false,
    users: [],
    invoices: [],
    lastInvoices: [],
    providersTotal: 0,
    invoicesChartTotal: 0,
    invoicesChart: {},
    invoicesChartNumbers: [],
    invoicesChartDays: [],
    invoicesTotal: 0,
    maxValuePosition: 0,
    statusInvoice: "",
    listStatusInv: [],
    januaMont: [],
    februMont: [],
    marchMont: [],
    aprilMont: [],
    mayMont: [],
    juneMont: [],
    julyMont: [],
    augustMont: [],
    septeMont: [],
    octobMont: [],
    novembMont: [],
    decembMont: [],
  }),
  computed: {
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          summary: "Resumen",
          monthlySummary: "Resumen mensual por estado - 2025",
          invoices: "Facturas",
          total: "Total",
          users: "Usuarios",
          active: "Activo",
          inactive: "Inactivo",
          providers: "Total Proveedores",
          lastInvoices: "Últimas Facturas",
          provider: "Proveedor",
          date: "Fecha",
          noInvoices: "Aún no cuentas con facturas",
          statusInv: "Estado",
          approved: "Aprobada",
          checked: "Revisada",
          declined: "Rechazada",
          pending: "Pendiente",
          selectState: "Seleccione un estado:",
          monthJanua: "Enero",
          monthFebrua: "Febrero",
          monthMarch: "Marzo",
          monthApril: "Abril",
          monthMay: "Mayo",
          monthJune: "Junio",
          monthJuly: "Julio",
          monthAugust: "Agosto",
          monthSeptember: "Septiembre",
          monthOctober: "Octubre",
          monthNovember: "Noviembre",
          monthDecember: "Diciembre",
        };
      } else {
        return {
          summary: "Summary",
          monthlySummary: "Monthly summary by state - 2025",
          invoices: "Invoices",
          total: "Total",
          users: "Users",
          active: "Active",
          inactive: "Inactive",
          providers: "Providers Total",
          lastInvoices: "Last Invoices",
          provider: "Provider",
          date: "Date",
          noInvoices: "No invoices Found",
          statusInv: "Status",
          approved: "Approved",
          checked: "Checked",
          declined: "Declined",
          pending: "Pending",
          selectState: "Select a state:",
          monthJanua: "January",
          monthFebrua: "February",
          monthMarch: "March",
          monthApril: "April",
          monthMay: "May",
          monthJune: "June",
          monthJuly: "July",
          monthAugust: "August",
          monthSeptember: "September",
          monthOctober: "October",
          monthNovember: "November",
          monthDecember: "December",
        };
      }
    },
    role() {
      // console.log(this.$store.state.userRole)
      return this.$store.state.userRole;
    },
    pages() {
      return this.labels.pages.filter((page) => {
        return page.roles.find((item) => {
          return item === this.$store.state.userRole;
        });
      });
    },
  },
  methods: {
    statusMonthly(){
      // console.log(this.statusInvoice)
      this.spinn = true;
      Invoice.getInvoiceByStatus(this.statusInvoice)
      .then((rta) => {
        // console.log(rta.data.invoices)
        this.spinn = false;
        this.listStatusInv = rta.data.invoices;
        this.prueba(this.listStatusInv)
      })
      .catch(()=>{

      })
    },
    prueba(statusInv){
      // console.log(statusInv.length)
      this.januaMont = [];
      this.februMont = [];
      this.marchMont = [];
      this.aprilMont = [];
      this.mayMont = [];
      this.juneMont = [];
      this.julyMont = [];
      this.augustMont = [];
      this.septeMont = [];
      this.octobMont = [];
      this.novembMont = [];
      this.decembMont = [];
      // this.spinn = true;

      if(statusInv.length != 0){
        for(let i=0; i < statusInv.length; i++){
          // console.log(statusInv[i].createdAt.slice(5,7))
          if(statusInv[i].createdAt.slice(5,7) == '01'){
            this.januaMont.push(statusInv[i].createdAt);

          }else if(statusInv[i].createdAt.slice(5,7) == '02'){
            this.februMont.push(statusInv[i].createdAt);

          }else if(statusInv[i].createdAt.slice(5,7) == '03'){
            this.marchMont.push(statusInv[i].createdAt);

          }else if(statusInv[i].createdAt.slice(5,7) == '04'){
            this.aprilMont.push(statusInv[i].createdAt);

          }else if(statusInv[i].createdAt.slice(5,7) == '05'){
            this.mayMont.push(statusInv[i].createdAt);

          }else if(statusInv[i].createdAt.slice(5,7) == '06'){
            this.juneMont.push(statusInv[i].createdAt);

          }else if(statusInv[i].createdAt.slice(5,7) == '07'){
            this.julyMont.push(statusInv[i].createdAt);
          
          }else if(statusInv[i].createdAt.slice(5,7) == '08'){
            this.augustMont.push(statusInv[i].createdAt);
          
          }else if(statusInv[i].createdAt.slice(5,7) == '09'){
            this.septeMont.push(statusInv[i].createdAt);
          
          }else if(statusInv[i].createdAt.slice(5,7) == '10'){
            this.octobMont.push(statusInv[i].createdAt);
          
          }else if(statusInv[i].createdAt.slice(5,7) == '11'){
            this.novembMont.push(statusInv[i].createdAt);
          
          }else if(statusInv[i].createdAt.slice(5,7) == '12'){
            this.decembMont.push(statusInv[i].createdAt);
          
          }
        }
        // console.log(this.juneMont.length)
      }
    }
  },
  mounted() {
    this.isLoading = true;
    this.currentDay = new Date().getDate();
      Invoice.getAllDash()
        .then((fetchedData) => {
          this.invoices = fetchedData.data.invoices;
          this.invoicesTotal = this.invoices.length;
          if (this.invoicesTotal > 6) {
            this.lastInvoices = this.invoices.slice(0, 4);
          } else {
            this.lastInvoices = this.invoices;
          }
          this.invoices.forEach((element) => {
            if (element.createdAt.slice(0, 5) in this.invoicesChart) {
              this.invoicesChart[element.createdAt.slice(0, 5)] += 1;
            } else {
              this.invoicesChart[element.createdAt.slice(0, 5)] = 1;
            }
          });
          this.invoicesChartDays = Object.keys(this.invoicesChart);
          this.invoicesChartNumbers = Object.values(this.invoicesChart);
          if (this.invoicesChartDays > 5) {
            this.invoicesChartDays = this.invoicesChartDays.slice(0, 5);
            this.invoicesChartNumbers = this.invoicesChartNumbers.slice(0, 5);
          }
          this.maxValuePosition = this.invoicesChartNumbers.indexOf(
            Math.max(...this.invoicesChartNumbers)
          );
          this.invoicesChartTotal = this.invoicesChartNumbers.reduce(
            (a, b) => a + b,
            0
          );
        })
        .catch(() => {
          this.error = true;
        });
      Provider.getAll()
        .then((fetchedData) => {
          this.providersTotal = fetchedData.data.data.length;
        })
        .catch(() => {
          this.error = true;
        });

      User.getAllUsers()
        .then((fetchedData) => {
          this.users = fetchedData.data.users;
          if (this.users.length > 4) {
            this.users = this.users.slice(0, 4);
          }
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    
  },
};
</script>

<style src="../main.css"></style>
